import { useState } from 'react'

import { DSButton, Table as DSTable, TableAlign } from '@vr/ds-react'

import { TableCollaboratorProps } from './interface'
import { BoxRounded } from './styled'
import ModalConfirmationRemoveCollaborator from '../modal-confirmation-remove-collaborator'
import { COLLABORATOR_LIST_COLUMNS } from '@/constants/collaborator-list-columns'

export const TableCollaborator = ({
  items,
  handleRemove
}: TableCollaboratorProps) => {
  const [collaborator, setCollaborator] = useState(false)

  return (
    <>
      <BoxRounded>
        <DSTable
          skeleton={{
            columns: 3,
            rows: 10
          }}
          css={{
            width: '100%',
            marginTop: '20px',
            boxShadow: 'none !important',
            borderBottomLeftRadius: '0',
            borderBottomRightRadius: '0'
          }}
        >
          <DSTable.Head>
            {COLLABORATOR_LIST_COLUMNS.map(item => (
              <DSTable.Cell
                key={item.field}
                id={item.field}
                align={item.align as TableAlign}
              >
                {item.headerName}
              </DSTable.Cell>
            ))}
          </DSTable.Head>
          <DSTable.Body>
            {items.map(item => (
              <DSTable.Row key={item.id} id={item.id?.toString()}>
                {COLLABORATOR_LIST_COLUMNS.map(key => (
                  <DSTable.Cell key={key.field} align={key.align as TableAlign}>
                    {key.field === 'acoes' ? (
                      <DSButton
                        variant='ghost'
                        size='small'
                        onClick={() => {
                          // setShowModal(true)
                          setCollaborator(item)
                        }}
                        outlined={false}
                        iconLeft='principal-trash'
                        css={{ margin: 'auto' }}
                      />
                    ) : (
                      item[key.field as keyof typeof item]
                    )}
                  </DSTable.Cell>
                ))}
              </DSTable.Row>
            ))}
          </DSTable.Body>
        </DSTable>
      </BoxRounded>
      {collaborator && (
        <ModalConfirmationRemoveCollaborator
          collaborator={collaborator}
          onClose={() => setCollaborator(null)}
          handleRemove={() => handleRemove(collaborator)}
        />
      )}
    </>
  )
}
